import { render, staticRenderFns } from "./ccm-matchpaper-apply.vue?vue&type=template&id=2ff22287&"
import script from "./ccm-matchpaper-apply.vue?vue&type=script&lang=js&"
export * from "./ccm-matchpaper-apply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports